import { useMemo } from "react";
import { useReactiveVar } from "@apollo/client";
import { mobileAppModel } from "../../state";
import { mediaCardsQuantity } from "../../constants";
import { MediaCardFilled } from "./MediaCardFilled";
import { MediaCardEmpty } from "./MediaCardEmpty";
import { MediaCardContainer } from "./Style";

export const MediaCards = () => {
  const model = useReactiveVar(mobileAppModel.model);
  const isLoading = useReactiveVar(mobileAppModel.updateLoading);

  const mediaCards =
        model?.contentPreviews?.length > mediaCardsQuantity
      ? model?.contentPreviews?.slice(0, mediaCardsQuantity)
      : model?.contentPreviews;

  const filledItemsCount = mediaCards?.length || 0;
  const emptyItemsCount = mediaCardsQuantity - filledItemsCount;

  const filledItems = useMemo(
    () =>
      mediaCards?.map(({ id, url }) => (
        <MediaCardFilled
          key={id}
          id={id}
          mediaURL={url}
        />
      )),
    [mediaCards]
  );

  const emptyItems = useMemo(
    () =>
      Array.from({ length: emptyItemsCount }).map((_, index) => {
        const isDisable = index > 0 || isLoading;
        return (
          <MediaCardEmpty
            key={index}
            isDisable={isDisable}
          />
        );
      }),
    [emptyItemsCount, isLoading]
  );


  return (
    <MediaCardContainer $isLocked={ isLoading }>
        {filledItems}
        {emptyItems}
    </MediaCardContainer>
  );
};
